var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgDiamond = function SvgDiamond(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m26.852 29.674.625-25.31-6.344-1.69-4.933.556-10.582 7.387-2.2 4.446-.579 6.553 24.013 8.058Z",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m3.418 15.063 6.6-1.343 7.572-5.303 3.543-5.743M27.477 4.365l-4.237 8.058-11.393 7.966-9.008 1.227",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.852 29.674 11.847 20.39l-1.83-6.669M26.852 29.674 23.24 12.423l-5.65-4.006",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export default SvgDiamond;